import { getLinkToInboxProviders } from './email-service';

export const findProvider = (email: string, jrConfigGlobal: JrConfigGlobal = window.jrConfigGlobal): LinkToInboxProvider[] => {
  const { linkToInbox: { enabled = false } } = jrConfigGlobal;

  return enabled ? getLinkToInboxProviders(email) : [];
}